import { render, staticRenderFns } from "./AvailabilityStats.vue?vue&type=template&id=c5f3e130&"
import script from "./AvailabilityStats.vue?vue&type=script&lang=js&"
export * from "./AvailabilityStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports